var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRelogio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#F5E6D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0208 27.8125L27.8125 26.0208L23.0774 21.2857V15.3988H20.5179V22.3095L26.0208 27.8125ZM21.7976 34.5953C20.0273 34.5953 18.3636 34.2593 16.8066 33.5874C15.2495 32.9156 13.8951 32.0037 12.7433 30.852C11.5915 29.7002 10.6797 28.3458 10.0078 26.7887C9.33594 25.2317 9 23.568 9 21.7976C9 20.0273 9.33594 18.3636 10.0078 16.8066C10.6797 15.2495 11.5915 13.8951 12.7433 12.7433C13.8951 11.5915 15.2495 10.6797 16.8066 10.0078C18.3636 9.33594 20.0273 9 21.7976 9C23.568 9 25.2317 9.33594 26.7887 10.0078C28.3458 10.6797 29.7002 11.5915 30.852 12.7433C32.0037 13.8951 32.9156 15.2495 33.5874 16.8066C34.2593 18.3636 34.5953 20.0273 34.5953 21.7976C34.5953 23.568 34.2593 25.2317 33.5874 26.7887C32.9156 28.3458 32.0037 29.7002 30.852 30.852C29.7002 32.0037 28.3458 32.9156 26.7887 33.5874C25.2317 34.2593 23.568 34.5953 21.7976 34.5953ZM21.7976 32.0357C24.6344 32.0357 27.05 31.0386 29.0443 29.0443C31.0386 27.05 32.0357 24.6344 32.0357 21.7976C32.0357 18.9608 31.0386 16.5453 29.0443 14.551C27.05 12.5567 24.6344 11.5595 21.7976 11.5595C18.9608 11.5595 16.5453 12.5567 14.551 14.551C12.5567 16.5453 11.5595 18.9608 11.5595 21.7976C11.5595 24.6344 12.5567 27.05 14.551 29.0443C16.5453 31.0386 18.9608 32.0357 21.7976 32.0357Z",
    fill: "#F7943E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRelogio);
export default __webpack_public_path__ + "static/media/icon_relogio.98d6601e25f567d9d723a16809a43ba8.svg";
export { ForwardRef as ReactComponent };